import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import GlobalConst from "../../../Core/Utils/Constants/globals";
import { NewRequestMetadataInputProps } from "../new-request-metadata-input";

const NewRequestInputDate = (props: NewRequestMetadataInputProps) => {
  const { metadata, value, isErrored: isMandatory, onChange } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        value={!value ? null : dayjs(value)}
        onChange={(newValue) => onChange(newValue?.toString())}
        format={GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS}
        sx={{ mt: "-24px" }}
      />
    </LocalizationProvider>
  );
};

export default NewRequestInputDate;
